import { useEffect, useRef } from 'react';

/**
 * يمرّر الصفحة إلى لوحة التفاصيل حين تُفتح: الضغط على صف فى آخر القائمة كان يرسم
 * التفاصيل تحتها خارج مجال الرؤية فيبدو أن لا شىء حدث. `key` معرّف ما فُتح — تغييره
 * يعيد التمرير، و`null` يعنى لا شىء مفتوح.
 */
export function useRevealOnOpen<T extends HTMLElement>(key: string | null | undefined) {
  const ref = useRef<T>(null);
  useEffect(() => {
    if (!key) return;
    const reduced = window.matchMedia?.('(prefers-reduced-motion: reduce)').matches ?? false;
    ref.current?.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
  }, [key]);
  return ref;
}
